<div class="row p-0 m-0" style="padding: 0.5rem 0.1rem !important">
  <!-- <button *ngIf="!activated" type="button" (click)="toggleModal(modal)"
          class="btn btn-success rounded text-uppercase font-weight-bold m-auto">
    <fa-icon class="white-icon p-2" [icon]="['fa', 'lock']"></fa-icon>
    Change Password
  </button> -->
  <button
    *ngIf="!activated"
    type="button"
    (click)="toggleModal(modal)"
    class="btn btn-success bg-transparent border-0 text-left"
    style="font-weight: 500"
  >
    <fa-icon
      class="white-icon pr-2"
      [icon]="['fa', 'lock']"
      style="opacity: 0.5"
    ></fa-icon>
    Change Password
  </button>
</div>

<ng-template #modal>
  <div class="modal-header rounded">
    <h4 class="modal-title pull-left">Change password</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <form
          [formGroup]="resetPasswordForm"
          (ngSubmit)="submit()"
          role="form"
          class="app-login-form rounded p-2"
        >
          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control rounded-right"
              formControlName="oldPassword"
              placeholder="Old password"
            />
          </div>
          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control rounded-right"
              formControlName="newPassword"
              placeholder="New password"
            />
          </div>
          <div class="input-group mb-4">
            <input
              type="password"
              class="form-control rounded-right"
              formControlName="newPasswordRepeat"
              placeholder="Repeat new password"
            />
          </div>
          <div>
            <label class="error p-0">{{ errorMessage }}</label>
          </div>
          <button
            type="submit"
            [disabled]="
              resetPasswordForm.invalid || !checkPasswords() || loading
            "
            class="btn btn-primary rounded btn-block text-uppercase font-weight-bold"
          >
            Reset
          </button>
        </form>
      </div>
    </div>
  </div>
</ng-template>
